import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'out-footer',
  imports: [RouterLink, CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  @Input() logoSrc = '';

  models = [
    {
      name: 'Used Cybertruck For Sale',
      link: '/used-tesla-cybertruck-for-sale',
    },
    {
      name: 'Used Model S For Sale',
      link: '/used-tesla-model-s-for-sale',
    },
    {
      name: 'Used Model 3 For Sale',
      link: '/used-tesla-model-3-for-sale',
    },
    {
      name: 'Used Model X For Sale',
      link: '/used-tesla-model-x-for-sale',
    },
    {
      name: 'Used Model Y For Sale',
      link: '/used-tesla-model-y-for-sale',
    },
    {
      name: 'Used Roadster For Sale',
      link: '/used-tesla-roadster-for-sale',
    },
  ];

  listingType = [
    {
      name: 'For Sale',
      link: '/categories/type/for-sale',
    },
    {
      name: 'Lease Takeover',
      link: '/categories/type/lease-takeover',
    },
    {
      name: 'Sale Pending',
      link: '/categories/type/sale-pending',
    },
  ];

  supports = [
    {
      name: 'About Us',
      link: '/about-only-used-tesla',
    },
    {
      name: 'Cash Offer',
      link: '/cash-offer',
    },
    {
      name: 'Dealers: Advertise your Inventory',
      link: '/dealers',
      unique: true,
    },
    // {
    //   name: 'Tesla News',
    //   link: 'https://blog.onlyusedtesla.com/',
    //   external: true,
    // },
    {
      name: 'Frequently Asked Questions',
      link: '/frequently-asked-questions',
    },
    {
      name: 'Fraud Awareness',
      link: '/fraud-awareness',
    },
    {
      name: 'Contact Us',
      link: '/contact',
    },
    {
      name: 'Visitor Agreement',
      link: '/visitor-agreement',
    }
  ];
}
